/**
 * One recipe for a raised panel, and one for how a panel responds to a pointer.
 *
 * There were four, and they disagreed on all four properties. The table
 * skeleton painted `bg-card shadow-sm`; the table it turned into painted no
 * background at all, so on the pages that place a table straight on the page a
 * white panel appeared while loading and vanished when the rows arrived. Card
 * rounded to 12px and MetricCard to 16px, so a KPI strip and the card beside it
 * had visibly different corners. Card cast a pure-black shadow and MetricCard a
 * tinted one, which on a graphite ground is the difference between a panel
 * sitting on the page and a panel smudging it.
 *
 * Resolved towards what was already dominant — 12px, used in 233 places against
 * 66 — and towards the tinted shadow, which was the considered one.
 *
 * This covers *resting* panels only. Overlays and floating bars sit higher on
 * purpose and keep their own, larger shadows.
 *
 * Strings rather than components: every consumer is already a div with its own
 * layout classes, and wrapping each one in another element just to inherit a
 * background would add a box for nothing.
 */
export const PANEL = 'rounded-lg border border-border bg-card shadow-raised';

/**
 * The lift a panel gets when it is something you can click.
 *
 * Named properties rather than `all`. `transition-all` animates layout too, so
 * a card whose content reflows — a value arriving, a subtitle wrapping —
 * animates its own height, which reads as the interface settling rather than
 * responding.
 *
 * 150ms rather than 200: a hover that lags the pointer feels like weight, and
 * this one is meant to feel like paper.
 */
export const PANEL_LIFT = [
  'hover:shadow-raised-hover hover:-translate-y-0.5',
  'transition-[box-shadow,transform] duration-150 ease-out',
  'motion-reduce:transition-none motion-reduce:hover:translate-y-0',
].join(' ');
